import { AskRow, AskStatus } from "namirasoft-inference";
import { NSLoading } from "namirasoft-site-react";
import { Component } from "react";
import { formatDuration } from "./Interaction";
import Styles from "./Interaction.module.css";

interface AskProps
{
    ask: AskRow;
}

// An ask that never produced an interaction: rejected by a guard rail or a budget before any
// model ran, or still dispatching. It is rendered in the same shape as an interaction so the
// chat reads as one timeline.
class Ask extends Component<AskProps>
{
    override render()
    {
        let a = this.props.ask;
        let createdAtLabel = new Date(a.created_at).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
        let updatedAtLabel = new Date(a.updated_at).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
        let inProgress = a.status === AskStatus.Running;
        return (
            <div className={Styles.ns_interaction}>
                <div className={Styles.ns_user}>
                    <div className={Styles.ns_bubble_user}>{a.message_user}</div>
                    <div className={Styles.ns_bubble_user_time}>{createdAtLabel}</div>
                </div>
                <div className={Styles.ns_ai_head_row}>
                    <div className={Styles.ns_ai_head}>
                        <span className={Styles.ns_ai_provider}>{a.inferencer_type}</span>
                        <span className={Styles.ns_ai_dot}>·</span>
                        <span className={Styles.ns_ai_model}>{a.inferencer_id}</span>
                        {
                            a.run_id &&
                            <>
                                <span className={Styles.ns_ai_dot}>·</span>
                                <span className={Styles.ns_ai_run_id} title={`Run ID: ${a.run_id}`}>Run ID: {a.run_id}</span>
                            </>
                        }
                    </div>
                </div>
                {
                    inProgress ?
                        <NSLoading title="Thinking" description="Awaiting a response ..." /> :
                        <div className={Styles.ns_bubble_error}>{a.message_error || "Something went wrong."}</div>
                }
                <div className={Styles.ns_meta}>
                    <div className={Styles.ns_meta_row}>
                        <span className={Styles.ns_meta_item}>
                            {updatedAtLabel}
                        </span>
                        {
                            !inProgress &&
                            <span className={Styles.ns_meta_item} title="Response duration">
                                <strong>Duration:</strong> {formatDuration(a.duration)}
                            </span>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Ask;